import { takeLatest, put, call, select } from 'redux-saga/effects';
import { UPDATE_USER_SAGA } from "../sagaTypes";
import { loaderAction, photoFileAction, userFormAction } from "../rootReducer";
import { url } from "../../config";
import growl from "../../lib/growl/growl";
import { setLocalStorage } from "../../helpers/LocalStorage";
import { getUserInfoSagaAction } from "../sagaActions";
import { USER_FORM_INITIAL } from "../initialStateConstant";

const request = data => {
    return fetch(`${ url }/update_user`, {
        method: 'post',
        body: data
    })
        .then(response => response.json()).catch(error => console.log(error))
};

function* workerUpdateUser(args) {
    const user = yield select(state => state.user);

    yield put(loaderAction(true));
    try {
        let formData = new FormData();
        formData.append('user_id', user.id);
        formData.append('hash', user.hash);
        formData.append('user', args.data.id);
        formData.append('name', args.data.name);
        formData.append('phone', args.data.phone);
        formData.append('email', args.data.email);
        formData.append('image', args.data.avatar?.file || args.data.avatar);
        formData.append('sex', args.data.sex);
        formData.append('note', args.data.note);
        formData.append('birthday', args.data.birthday);
        formData.append('additional_id', args.data.additional_id);
        formData.append('links', args.data.links);

        const response = yield call (request, formData);

        // Если не прошли проверку хеша разлогиниваемся
        if (response.void) {
            setLocalStorage('afp_fitness', '').then(() => window.location.reload());
        }

        if (response.success) {
            // Закрываем форму посетителя
            yield put(userFormAction(USER_FORM_INITIAL));
            // Обновляем данные о посетителе
            yield put(getUserInfoSagaAction({ id: args.data.id }));
            yield put(photoFileAction(null));
            growl({ type: 'success', message: response.message });
        }
        else if (response.error) {
            growl({ type: 'error', message: response.message });
        }
    }
    catch(error) {
        console.log(error);
        yield put(loaderAction(false));
    }
    finally {
        yield put(loaderAction(false));
    }
}

export default function* watcherUpdateUser() {
    yield takeLatest(UPDATE_USER_SAGA, workerUpdateUser);
}